import axios from "axios";
import { baseURL } from "../../constants/Api";

export const request_lost_tem = async (obj) => {
   const appUserId = localStorage.getItem("appUserId");

  let config = {
    method: "post",
    url: `${baseURL}/api/lostitemV21`,
    headers: {
      Accept: "application/json",
    },
    data: {
      hotelId: obj?.bookingObj?.hotelId,
      reservationId: obj?.bookingObj?.reservationId,
      appUserId: appUserId,
      comment: obj?.comments,
    },
  };

  try {
    const response = await axios.request(config);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
